import { Card, CardContent, Grid, Typography } from "@mui/material";
// import { data } from "./data";
import { useEffect, useState } from "react";
import { IVisitorResult } from "features/libraryDashboard/api/types";
import { GetVisitorWidgets } from "features/libraryDashboard/api/hooks";
const VisitorStatistics = () => {
  const { data: result } = GetVisitorWidgets();
  const [visitors, setVisitors] = useState<IVisitorResult>();

  useEffect(() => {
    if (result?.status === 200) {
      setVisitors(result?.apiData);
    }
  }, [result?.apiData]);
  return (
    <>
      <Grid>
        <Typography variant="h2">Visitors</Typography>
      </Grid>
      <Grid container spacing={2.5} sx={{ my: 1 }}>
        <Grid item sm={12} md={12} xs={12}>
          <Card>
            <CardContent>
              <Grid
                container
                sx={{
                  padding: "10px 10px",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  alignItems: "center",
                }}
              >
                <Grid item xs={12} sx={{ pb: 3 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      color: "#757575",
                    }}
                  >
                    Today
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      fontSize: "20px",
                    }}
                  >
                    {visitors?.todayVisitors.toLocaleString("en-IN")}
                  </Typography>
                </Grid>

                <Grid item xs={12} sx={{ pb: 3 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      color: "#757575",
                    }}
                  >
                    Last 7 Days
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      fontSize: "20px",
                    }}
                  >
                    {visitors?.last7DaysVisitors.toLocaleString("en-IN")}
                  </Typography>
                </Grid>
                <Grid item xs={12} sx={{ pb: 2 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      color: "#757575",
                    }}
                  >
                    Last Month
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      fontSize: "20px",
                    }}
                  >
                    {visitors?.lastMonthVisitors.toLocaleString("en-IN")}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};
export default VisitorStatistics;
